import { useEffect, useState } from 'react'
import { Form, Icon, TextArea } from 'semantic-ui-react'
import { StyledButton } from '../common/styledComponents'
import {
  FormDataset,
  mapToFormDataset,
  mapToDataset,
  Dataset,
} from '@confluent-cfet-medusa/dataset-designer'

interface MedusaRequestHandlerProps {
  datasetDesignerFormData: FormDataset
  setDatasetDesignerFormData: React.Dispatch<React.SetStateAction<FormDataset>>
}

const MedusaRequestHandler = (props: MedusaRequestHandlerProps) => {
  const { datasetDesignerFormData, setDatasetDesignerFormData } = props
  const [medusaRequestString, setMedusaRequestString] = useState<string>('')
  const [showCopySuccess, setShowCopySuccess] = useState(false)
  const [showPasteSuccess, setShowPasteSuccess] = useState(false)
  const [showPasteError, setShowPasteError] = useState(false)

  useEffect(() => {
    setMedusaRequestString(JSON.stringify(mapToDataset(datasetDesignerFormData)))
  }, [datasetDesignerFormData])

  const onCopyMedusaRequest = () => {
    navigator.clipboard.writeText(medusaRequestString)
    setShowCopySuccess(true)
    setTimeout(() => setShowCopySuccess(false), 2000)
  }

  const onPasteMedusaRequest = () => {
    navigator.clipboard.readText().then((text) => {
      try {
        const unescapedJson = text.replace(/\\"/g, '"').replace(/\\\\/g, '\\')
        const medusaRequest: Dataset = JSON.parse(unescapedJson)
        const pastedDatasetDesignerFormData = mapToFormDataset(medusaRequest)
        setDatasetDesignerFormData(pastedDatasetDesignerFormData)
        setShowPasteSuccess(true)
        setTimeout(() => setShowPasteSuccess(false), 2000)
      } catch (error) {
        console.error('Failed to parse JSON:', error)
        setShowPasteError(true)
        setTimeout(() => setShowPasteError(false), 2000)
      }
    })
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          paddingBottom: '10px',
        }}
      >
        <StyledButton onClick={onCopyMedusaRequest}>
          {showCopySuccess ? (
            <Icon
              name="check"
              color="green"
            />
          ) : (
            <Icon name="copy" />
          )}
          Copy Mockstream Dataset
        </StyledButton>
        <StyledButton onClick={onPasteMedusaRequest}>
          {showPasteSuccess ? (
            <Icon
              name="check"
              color="green"
            />
          ) : showPasteError ? (
            <Icon
              name="warning"
              color="red"
            />
          ) : (
            <Icon name="paste" />
          )}
          Paste Mockstream Dataset
        </StyledButton>
      </div>
      <div>
        <Form>
          <TextArea value={medusaRequestString} />
        </Form>
      </div>
    </>
  )
}

export default MedusaRequestHandler
